import { Separator, Typography } from '@kustom-checkout/morpheus';

import { LogoWrapper } from './LogoWrapper';

export function Header() {
  return (
    <header>
      <Separator />
      <div className="flex flex-row items-center justify-between px-4 py-2">
        <LogoWrapper />
        <Typography variant="p" color="muted">
          The smoooth partner shipping integrator
        </Typography>
      </div>
      <Separator />
    </header>
  );
}
